import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <Result
        status="403"
        icon={<LockOutlined style={{ fontSize: 72, color: '#ff4d4f' }} />}
        title="Acesso Negado"
        subTitle="Você não tem permissão para acessar esta página. Se acredita que deveria ter acesso, contate um administrador."
        extra={[
          <Button type="primary" key="home" onClick={() => navigate('/home')}>
            Voltar para Home
          </Button>,
          <Button key="projects" onClick={() => navigate('/projetos')}>
            Ver Projetos
          </Button>,
        ]}
      />
    </div>
  );
}
